// data/languages/swahili/categories/temps.ts

import { CategoryData } from '../../../../types/types';

export const temps: CategoryData = {
  'Jumatatu': { translation: 'Lundi', translationEn: 'Monday', audio: 'Sw-jumatatu', illustration: '1️⃣' },
  'Jumanne': { translation: 'Mardi', translationEn: 'Tuesday', audio: 'Sw-jumanne', illustration: '2️⃣' },
  'Jumatano': { translation: 'Mercredi', translationEn: 'Wednesday', audio: 'Sw-jumatano', illustration: '3️⃣' },
  'Alhamisi': { translation: 'Jeudi', translationEn: 'Thursday', audio: 'Sw-alhamisi', illustration: '4️⃣' },
  'Ijumaa': { translation: 'Vendredi', translationEn: 'Friday', audio: 'Sw-ijumaa', illustration: '5️⃣' },
  'Jumamosi': { translation: 'Samedi', translationEn: 'Saturday', audio: 'Sw-jumamosi', illustration: '6️⃣' },
  'Jumapili': { translation: 'Dimanche', translationEn: 'Sunday', audio: 'Sw-jumapili', illustration: '7️⃣' },
  'Jana': { translation: 'Hier', translationEn: 'Yesterday', audio: 'Sw-jana', illustration: '⬅️' },
  'Siku': { translation: 'Jour', translationEn: 'Day', audio: 'Sw-siku', illustration: '📆' },
  'Asubuhi': { translation: 'Matin', translationEn: 'Morning', audio: 'Sw-asubuhi', illustration: '🌅' },
  'Mchana': { translation: 'Après-midi', translationEn: 'Afternoon', audio: 'Sw-mchana', illustration: '🌇' },
  'Usiku': { translation: 'Nuit', translationEn: 'Night', audio: 'Sw-usiku', illustration: '🌙' },
  'Mwezi': { translation: 'Mois', translationEn: 'Month', audio: 'Sw-mwezi', illustration: '📅' },
  'Mwaka': { translation: 'Année', translationEn: 'Year', audio: 'Sw-mwaka', illustration: '🗓️' },
  'Saa': { translation: 'Heure', translationEn: 'Hour', audio: 'Sw-saa', illustration: '🗓️' },
  'Sekunde': { translation: 'Seconde', translationEn: 'Second', audio: 'Sw-sekunde', illustration: '🗓️' },
  'Dakika': { translation: 'Minute', translationEn: 'Minute', audio: 'Sw-dakika', illustration: '🗓️' },
};

export default temps;
